const makeDefaultState = () => ({
  salesData: {
    terminals: [],
    totals: {
      money: 0,
      cash: 0,
      card: 0,
      tax: 0,
      pictures: 0,
      count: 0
    }
  },
  isLoadingSales: false,

  actionsData: [],
  isLoadingActions: false,

  graphsData: [],
  isLoadingGraphs: false,
})

const state = makeDefaultState()

const mutations = {
  setSalesData(state, statics) {
    state.salesData = statics
  },
  setLoadingSales(state, value) {
    state.isLoadingSales = value
  },

  setActionsData(state, actions) {
    state.actionsData = actions
  },
  setLoadingActions(state, value) {
    state.isLoadingActions = value
  },

  setGraphsData(state, actions) {
    state.graphsData = actions
  },
  setLoadingGraphs(state, value) {
    state.isLoadingGraphs = value
  },

  resetState(state) {
    Object.assign(state,  makeDefaultState())
  }
}

const actions = {
  async refetchStatistics({ commit }, params) {
    commit('setLoadingSales', true)

    try {
      const result = await this.$http.get('/rest/statistic', {
        params: params
      })

      commit('setSalesData', result.data)
    } catch (err) {
      commit('setSalesData', {
        terminals: [],
        totals: {
          money: 0,
          cash: 0,
          card: 0,
          tax: 0,
          pictures: 0,
          count: 0
        }
      })
    } finally {
      commit('setLoadingSales', false)
    }
  },
  async refetchActions({ commit }, params) {
    commit("setLoadingActions", true)

    try {
      const result = await this.$http.get('/rest/statistic/actions', {
        params: params
      })

      commit('setActionsData', result.data)
    } finally {
      commit('setLoadingActions', false)
    }
  },
  async refetchGraphs({ commit }, params) {
    commit("setLoadingGraphs", true)

    try {
      const result = await this.$http.get('/rest/statistic/graphs', {
        params: params
      })

      commit('setGraphsData', result.data)
    } finally {
      commit('setLoadingGraphs', false)
    }
  }
}

export default  {
  namespaced: true,
  state,
  mutations,
  actions
}